import powerAgentsApi from 'dashboard/api/powerAgents';
import { noVocabularioDaConversa } from './transporteDoRascunho';

// O transporte do Playground no modo canal (L-27): o que `useConversaDoCanal` pede, falando com a
// caixa de teste do agente pelas rotas do painel, com a sessão de quem está nele, e não com o token
// do link. A conversa e a tela são as da página do link no mesmo modo: as mensagens chegam no mesmo
// formato, e os turnos também.
// - o envio é o do Playground de sempre (`playground`), que nesse modo escreve na caixa de teste com o
//   contato de teste do membro; a resposta traz a mensagem como a página a recebe. A nota de voz é a
//   própria mensagem, com a foto e o PDF escolhidos antes de gravar, e o job de produção a transcreve;
// - as rotas do painel dizem o código do erro em `error`, e a conversa lê `erro`
//   (`noVocabularioDaConversa`, a mesma tradução do transporte do rascunho);
// - `modo_trocado` é o agente que saiu do modo canal com a tela aberta: a conversa sai para quem a
//   usa buscar o agente de novo. O resto fica no turno, como no rascunho.
//
// `estado()` é o que a tela precisa para abrir: a caixa, o que a versão publicada decide na conversa
// (é ela que responde pelo caminho de produção) e a conversa viva do membro.
//
// A consulta das respostas leva as conversas que a tela mostra desde que abriu ou desde o último
// "Nova conversa": o número que a abertura e cada envio devolvem. O agente, ou quem assumiu, pode
// responder e encerrar a conversa antes da consulta seguinte, e a mensagem depois disso abre outra; o
// servidor lê as encerradas que a tela ainda mostra, como a página lê a da sessão. O "Nova conversa"
// as esquece, e o que chegar tarde nelas fica de fora, também como na página.
export const saidaDoCanal = e =>
  e?.response?.status === 409 && e.response.data?.erro === 'modo_trocado'
    ? 'modo_trocado'
    : null;

export function transporteDoCanal(ctx) {
  const canal = (chamada, ...argumentos) =>
    chamada(ctx.accountId(), ctx.agentId(), ...argumentos).catch(e => {
      throw noVocabularioDaConversa(e);
    });
  const conversasNaTela = new Set();
  const naTela = resposta => {
    if (resposta?.conversation_id)
      conversasNaTela.add(resposta.conversation_id);
    return resposta;
  };
  const enviar = (texto, arquivos) =>
    canal(powerAgentsApi.playgroundCanalEnviar, texto, arquivos).then(naTela);
  const aMensagem = ({ mensagem }) => mensagem;

  return {
    estado: () =>
      canal(powerAgentsApi.playgroundCanalEstado).then(estado => {
        conversasNaTela.clear();
        return naTela(estado);
      }),
    enviar: texto =>
      canal(powerAgentsApi.playgroundCanalEnviar, texto)
        .then(naTela)
        .then(aMensagem),
    enviarComAnexos: (texto, arquivos) =>
      enviar(texto, arquivos).then(aMensagem),
    // A duração é a do gravador, que a bolha já tem: o servidor não a guarda.
    subirAudio: (arquivo, _duracaoMs, arquivos = []) =>
      enviar(null, [arquivo, ...arquivos]).then(({ mensagem }) => ({
        mensagem,
      })),
    audio: mensagemId => canal(powerAgentsApi.playgroundCanalAudio, mensagemId),
    novas: depois =>
      canal(powerAgentsApi.playgroundCanalNovas, depois, [...conversasNaTela]),
    recomecar: () =>
      canal(powerAgentsApi.playgroundCanalRecomecar).then(resposta => {
        conversasNaTela.clear();
        return resposta;
      }),
    saida: saidaDoCanal,
  };
}
